import Content, { ContentNS } from "content/content";
import InfoBlock from "features/shared/styles/InfoBlock";
import Body from "features/shared/styles/typography/Body.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { FC } from "react";
import { useAppStore } from "store/store";

import StyledInfoCard from "./styles/StyledInfoCard.styled";
import ChecklistItem from "models/checklist/checklist-item/checklist-item";
import ExternalLinkButton from "features/shared/components/link/external-link/ExternalLinkButton";

interface InfoCardProps {
  item: ChecklistItem;
}

const InfoCard: FC<InfoCardProps> = ({ item }) => {
  useAppStore((state) => state.locale);

  const textDocs = (s: string, args: any = {}) =>
    Content.shared.t(s, { ns: ContentNS.docs, ...args });

  const title = textDocs("item-info-title", {
    itemTitle: item.title,
  });

  return (
    <StyledInfoCard>
      <InfoBlock>
        <Summary>{`${title}`}</Summary>
        <Body>{item.description}</Body>
        {item.externalLink ? (
          <ExternalLinkButton href={item.externalLink}>
            {`${textDocs("find-out-more")}`}
          </ExternalLinkButton>
        ) : null}
      </InfoBlock>
    </StyledInfoCard>
  );
};

export default InfoCard;
